import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, formatErr } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u.role === "admin" ? "/admin" : "/library");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <span className="label-overline">// Access</span>
      <h1 className="font-display text-5xl tracking-widest leading-none mt-3 mb-10">Sign in</h1>

      <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="label-overline block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#2A2018] border border-white/15 px-4 py-3 focus:border-[#D4A574] outline-none" data-testid="login-email-input" />
        </div>
        <div>
          <label className="label-overline block mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#2A2018] border border-white/15 px-4 py-3 focus:border-[#D4A574] outline-none" data-testid="login-password-input" />
        </div>
        <button disabled={loading} className="kinetic-btn w-full" data-testid="login-submit-btn">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <p className="mt-8 text-sm text-zinc-400">New here? <Link to="/register" className="text-[#D4A574]" data-testid="go-register-link">Create account</Link></p>
    </div>
  );
}
